import { configureStore } from '@reduxjs/toolkit'
import loadingReducer from "./reducers/loadingSlice";
import totalPagesSlice from './reducers/totalPagesSlice';

export const store = configureStore({
  reducer: {
    loading: loadingReducer,
    totalPages: totalPagesSlice,
  },
})